import { useState } from "react"
import { useTranslation } from "react-i18next"
import { PlaidLinkOnSuccessMetadata, usePlaidLink } from "react-plaid-link"
import { Button } from "@oysterhr/ui"
import usePlaidToken from "./hooks/usePlaidToken"
import useCreatePaymentMethodWithPlaid from "./hooks/useCreatePaymentMethodWithPlaid"

interface PlaidLinkFlowProps {
  onSubmit: () => void
  companyId: string
}

export const PlaidLinkFlow = ({ onSubmit, companyId }: PlaidLinkFlowProps) => {
  const [plaidBtnClicked, setPlaidBtnClicked] = useState(false)

  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchLandingPage")

  const { token } = usePlaidToken()
  const { createPaymentMethod } = useCreatePaymentMethodWithPlaid()

  const onSuccess = async (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => {
    await createPaymentMethod({
      variables: {
        ownerId: companyId,
        token: publicToken,
        // FIXME: (André) This was discussed with the Payments team, that for now this works since it's what's done on the BE
        // They will create cards on their board to fix this
        account: metadata.accounts[0],
        accounts: metadata.accounts,
      },
    })
    onSubmit()
  }

  const { open, ready } = usePlaidLink({
    token,
    onSuccess,
    onExit: () => setPlaidBtnClicked(false),
  })

  const openModal = () => {
    setPlaidBtnClicked(true)
    open()
  }

  const disabled = !token || !ready || plaidBtnClicked

  return (
    <div className="flex items-center">
      <Button
        data-analytics-name="company_payment_methods-ach-verify-account-with-plaid"
        disabled={disabled}
        onClick={openModal}
        isLoading={plaidBtnClicked}
      >
        {t("actions.verifyWithPlaid")}
      </Button>
    </div>
  )
}
